// Connexion : bouton SSO Orgazone (chemin normal) + formulaire LOCAL de secours (bris de glace).
// Le SSO part vers la route serveur /v1/auth/oidc/login (qui sonde l'IdP, repli local si down).
// ⚠️ Le compte de secours (admin@orgazone.fr) est LOCAL à la Console : il se connecte ICI, jamais sur l'IdP.
import { useEffect, useState, type FormEvent } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { api } from '../api';
import { useAuth } from '../auth';

export function Login() {
  const nav = useNavigate();
  const [sp] = useSearchParams();
  // ⚠️ `mode` vient du contexte (résolu UNE fois au boot) : cet écran le refetchait pour son seul bouton
  // SSO, soit une 3ᵉ lecture du même contrat dans la même app. Une résolution, une source.
  const { user, mode, refresh } = useAuth();
  const degraded = sp.get('degraded') === '1';
  const oidc = mode.oidc;
  const [email, setEmail] = useState('');
  const [pwd, setPwd] = useState('');
  const [err, setErr] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  useEffect(() => { if (user) nav('/', { replace: true }); }, [user, nav]); // déjà connecté → app

  const submit = async (e: FormEvent) => {
    e.preventDefault();
    setErr(null); setBusy(true);
    try {
      const r = await api.login(email.trim(), pwd, false);
      if (r.status === '2fa_required') { setErr('2FA requise — non gérée par cette page de secours.'); return; }
      // MODE DÉGRADÉ (§ bandeau shell) : un login LOCAL alors que le SSO est configuré = bris de glace —
      // la session entière doit le signaler (pas seulement cette page). Sans SSO configuré (Phase 1),
      // le login local est le mode NORMAL : pas de marquage. Levé à la déconnexion.
      if (oidc) sessionStorage.setItem('oz-degraded', '1');
      await refresh();
      nav('/', { replace: true });
    } catch (e) {
      setErr((e as Error).message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="authwrap">
      <form className="card" onSubmit={submit}>
        <h1>Orgazone Console</h1>
        <p className="sub">Plan de contrôle éditeur</p>

        {degraded && (
          <div className="banner">⚠️ IdP indisponible — connexion locale de secours (bris de glace).</div>
        )}

        {oidc && !degraded && (
          <>
            <a className="btn btn-cta block" href="/v1/auth/oidc/login">Se connecter avec Orgazone (SSO)</a>
            <div className="or">ou, en secours</div>
          </>
        )}

        <label htmlFor="email">E-mail</label>
        <input id="email" type="email" autoComplete="username" value={email} onChange={(e) => setEmail(e.target.value)} required autoFocus />
        <label htmlFor="pwd">Mot de passe</label>
        <input id="pwd" type="password" autoComplete="current-password" value={pwd} onChange={(e) => setPwd(e.target.value)} required />
        <button className="btn btn-cta" type="submit" disabled={busy}>{busy ? '…' : 'Connexion locale'}</button>
        {err && <div className="err">{err}</div>}
        {/* Le parcours de réinitialisation EXISTAIT côté serveur sans qu'aucun lien n'y mène : perdre
            le mot de passe de secours voulait dire re-semer le compte à la main. */}
        <p className="note">
          <a href="/reset" onClick={(e) => { e.preventDefault(); nav('/reset'); }}>Mot de passe oublié ?</a>
        </p>
        <p className="note">Accès réservé au personnel Orgazone. Le compte de secours ne sert qu'au 1ᵉʳ amorçage.</p>
      </form>
    </div>
  );
}
